import styled from 'styled-components';

interface CurrentIndicatorProps {
  top: number;
}

export const Wrapper = styled.div<CurrentIndicatorProps>`
  display: ${({ top }) => (top < 0 ? 'none' : 'block')};
  position: absolute;
  top: ${({ top }) => top}px;
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.palette.brand400};
  z-index: 14;

  width: 100vw;
  left: 0;

  max-width: var(--max-width);

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: -3px;
    left: 0;
    width: 8px;
    height: 8px;
    border-radius: 0 2px 2px 0;
    background-color: ${({ theme }) => theme.palette.brand400};
  }
`;
